import { REACT_APP_PERITADOR_API } from '../../config'
import axios from 'axios'
import { deepFreeze } from '../../../features/common/Utilities'
import {
  PERITAJE_PROCESADO,
  PERITAJE_PENDIENTE_GESTORIA,
  PERITAJE_USADO_INGRESADO,
  PERITAJE_VIGENCIA,
  PERITAJE_PENDIENTE,
  PERITAJE_STATUS
} from './constants'
import moment from 'moment'
import { isEmpty } from 'lodash'

/**
 *	@description Obtiene un peritaje
 *	@param {String} plate Patente del auto peritado
 *	@param {Boolean} isViewMode Si no es modo vista valida que tenga menos de 30 dias el peritaje.
 *	@param {Boolean} isCurrent Si se quiere solamente obtener peritajes validos (menos de 30 dias)
 *	@param {String} status Estado de peritaje, para aplicar como filtro
 *	@param {String} requestsId ID de peritaje, para aplicar como filtro
 *	@returns {Object<{peritaje, peritajeQuote}>} Retorna el peritaje y la cotizacion correspondiente si existe. 
 */
export async function getPeritaje(
    plate,
    isViewMode = false,
    isCurrent = false,
    status = null,
    requestsId = null
) {
    const requestFilter = createRequestFilter(plate, status, requestsId)

    if (isCurrent) {
        // Si se busca obtener solo peritajes validos,
        // se incorpora la unión con verification
        const limitDate = getVerificationLimitDate()
        requestFilter.include = {
            relation: 'verification',
            scope: {
                where: {
                    verificationDate: {
                        gt: limitDate
                    }
                }
            }
        }
    }

    const peritaje = await fetchRequest(requestFilter, isViewMode)

    let peritajeQuote
    if (peritaje) {
        // Si se incluyo el objeto verificación al filtro, y este no se encuentra
        // En el request, entonces se retorna un objeto vacio
        if (isCurrent && isEmpty(peritaje.verification)) {
            return {}
        }

        const hasQuote =
            Number(peritaje.statusId) === PERITAJE_PROCESADO ||
            Number(peritaje.statusId) === PERITAJE_PENDIENTE_GESTORIA ||
            Number(peritaje.statusId) === PERITAJE_USADO_INGRESADO

        if (hasQuote) {
            const verifiedQuoteFilters = {
                where: {
                    requestsId: peritaje.id
                },
                include: 'verification'
            }
            peritajeQuote = await fetchVerifiedQuote(verifiedQuoteFilters)
        }
    }

    return deepFreeze({ peritaje, peritajeQuote })
}


function createRequestFilter(plate, status, requestsId) {
  const requestFilter = {
    where: {
      servicePatent: plate,
      deletedAt: null
    },
    limit: 1,
    order: 'serviceDate DESC',
  };

  switch (status) {
    case PERITAJE_STATUS.PERITAJE_PENDIENTE:
      requestFilter.where.statusId = { inq: PERITAJE_PENDIENTE };
      break;
    case PERITAJE_STATUS.PERITAJE_FINALIZADO:
      requestFilter.where.statusId = PERITAJE_PROCESADO;
      requestFilter.where.presupuesto_reservado = false;
      requestFilter.where.recepcion_manual = false;
      break;
    case PERITAJE_STATUS.USADO_PENDIENTE_INGRESAR:
      requestFilter.where.statusId = PERITAJE_PROCESADO;
      requestFilter.where.or = [{
          presupuesto_reservado: true
        },
        {
          recepcion_manual: true
        }
      ];
      break;
    case PERITAJE_STATUS.USADO_PENDIENTE_GESTORIA:
      requestFilter.where.statusId = PERITAJE_PENDIENTE_GESTORIA;
      break;
    case PERITAJE_STATUS.USADOS_INGRESADO:
      requestFilter.where.statusId = PERITAJE_USADO_INGRESADO;
      break;
  }

  if (requestsId) {
    requestFilter.where.id = requestsId;
  }
  return requestFilter;
}
async function fetchRequest(filters, isViewMode) {
  const verPeritajeQuery = isViewMode ? '&verPeritaje=' + isViewMode : ''
  const endpoint = encodeURI(`${REACT_APP_PERITADOR_API}/requests?filter=${JSON.stringify(filters)}${verPeritajeQuery}`)
  const response = await axios(endpoint);
  return response.data?.[0];
}

async function fetchVerifiedQuote(filters) {
  const endpoint = encodeURI(`${REACT_APP_PERITADOR_API}/verifiedQuotes?filter=${JSON.stringify(filters)}&verPeritaje=true`)
  const response = await axios(endpoint)
  return response.data?.[0]
}

function getVerificationLimitDate() {
  return moment().add(-PERITAJE_VIGENCIA, 'days').format('MM/DD/YYYY')
}